import React, { FC, useEffect, useState } from 'react';
import StopIcon from '@mui/icons-material/Stop';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { IconButton } from '@mui/material';
import { log } from 'console';

interface AudioButtonProps {
  player: HTMLAudioElement;
  audioLinks: string[];
}

export const AudioButton: FC<AudioButtonProps> = ({ player, audioLinks }) => {
  const wordsPlayer: HTMLAudioElement = player;

  const [stop, setStop] = useState(false);

  useEffect(() => () => wordsPlayer.pause(), [wordsPlayer]);

  const playAudio = () => {
    setStop(false);
    wordsPlayer.pause();
    wordsPlayer.currentTime = 0;
    setStop(true);
    let audioIndex = 0;
    wordsPlayer.src = audioLinks[audioIndex];
    wordsPlayer.play();
    wordsPlayer.onended = () => {
      audioIndex += 1;
      if (audioIndex < audioLinks.length) {
        wordsPlayer.src = audioLinks[audioIndex];
        wordsPlayer.play();
        setStop(true);
      }
      if (audioIndex >= audioLinks.length) {
        setStop(false);
      }
    };
  };
  const stopAudio = () => {
    wordsPlayer.pause();
    wordsPlayer.currentTime = 0;
    setStop(false);
  };
  return (
    <div>
      {stop ? (
        <IconButton aria-label="play/pause" onClick={stopAudio}>
          <StopIcon sx={{ height: 38, width: 38 }} />
        </IconButton>
      ) : (
        <IconButton aria-label="play/pause" onClick={playAudio}>
          <PlayArrowIcon sx={{ height: 38, width: 38 }} />
        </IconButton>
      )}
    </div>
  );
};
